import { CircularProgressbar } from "react-circular-progressbar";

import { CircleText, ProgressContainer } from "pages/home/components/Layout";

/**
 * 건의 및 문의 미답변 그래프 컴포넌트
 */
export const BoxBody = ({
  suggestPer,
  suggestPer1,
  inquiriesPer,
  inquiriesPer1,
}) => {
  return (
    <ProgressContainer $width={145} $height={315} $background="#0079E0">
      {/* 건의 미답변 */}
      <div style={{ marginLeft: "22px", marginTop: "20px" }}>
        <CircleText>미답변</CircleText>
        <RateCircle total={suggestPer1} notAnswer={suggestPer} />
      </div>

      {/* 문의 미답변 */}
      <div
        style={{
          marginLeft: "22px",
          marginTop: "45px",
          marginBottom: "35px",
        }}
      >
        <RateCircle total={inquiriesPer1} notAnswer={inquiriesPer} />
      </div>
    </ProgressContainer>
  );
};

/**
 * 미답변 원형 그래프 컴포넌트
 */
const RateCircle = ({ total, notAnswer }) => {
  return (
    <CircularProgressbar
      text={`${total}건`}
      strokeWidth={14}
      value={notAnswer}
      styles={{
        root: {
          width: "100px",
          height: "100px",
        },
        path: {
          stroke: "#80BCF0",
          strokeLinecap: "butt",
          transform: "rotate(0.0turn)",
        },
        trail: {
          stroke: "#FFFFFF",
          transform: "rotate(0.0turn)",
        },
        text: {
          fill: "#FFF",
          fontSize: "16px",
          dominantBaseline: "middle",
          textAnchor: "middle",
        },
      }}
    />
  );
};
